import { render, staticRenderFns } from "./CourseFormFields.vue?vue&type=template&id=431aa984"
import script from "./CourseFormFields.vue?vue&type=script&lang=js"
export * from "./CourseFormFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports